














import Vue from 'vue';
import _ from 'lodash';
import { API } from "aws-amplify";
import { Constants } from "@/api-constants";
import { mapState, mapGetters } from 'vuex';
import VpTeamCard from '@/components/team/teams-card.vue';

export default Vue.extend({

  name: 'TeamResults',

  components: {
    'vp-team-card': VpTeamCard,
  },

  props: {
  },

  data() {
    return {
      teams: [] as any,
      myViewpoints: [] as any,
      sharedViewpoints: [] as any,
      updatedFlag: 0,
      trashConfirm: false,
      trashId: '' as any,
      trashName: '' as any,
    };
  },

  created() {
    this.loadTeams();
  },

  mounted() {

  },

  watch: {
    getInstanceId(newVal, oldVal) {
      this.loadTeams();
    },
    getVpGroups(newVal, oldVal) {
      this.loadTeams();
    },
  },

  computed: {
    // mix the getters into computed
    ...mapGetters([
      'getUserId',
      'getFavourites',
      'getIsLoggedIn',
      'getInstanceId',
      'getVpInstances',
      'getVpInstancesCount',
      'getVpInstanceList',
      'getVpInstanceListCount',
      'getVpGroups',
      'getVpGroupsCount',
      'getVpGroupsList',
      'getVpGroupsListCount',
      'getVpGroupInstances',
      'getVpGroupInstancesCount',
      'getVpGroupInstancesList',
      'getVpGroupInstancesListCount'
    ]),


    filteredTeams(): any {
      let filteredTeams: any[] = _.cloneDeep(this.teams);
      const userId: string = this.getUserId;
      for (const team of filteredTeams) {
        if (team.ownerUserId == userId) {
          team.name = '☆ ' + team.name + ' (' + team.viewpoints.length + ')';
        } else {
          team.name = team.name + ' (' + team.viewpoints.length + ')';
        }
      }
      return filteredTeams;
    },

  },

  methods: {

    loadTeams() {
      if (this.getVpGroups.length) {
        this.teams = [];
        for (const team of this.getVpGroups) {
          this.teams.push(team);
        }
      } else {
        this.teams = [];
      }
    },

  },


});

